import { memo, useEffect, useRef } from 'react';
import { Background } from '@shuwen/wenlv-web-activity-library';
import { getAssetUrl } from "@/utils/common";
import styles from './index.module.scss';
import { useStore } from '@/store';
import { PageMode } from '@/store/types';

const Silent = () => {
  const mode = useStore((state) => state.mode);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (mode === PageMode.SILENT) {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }
  }, [mode]);
  return (
    <Background className={styles.container} url={getAssetUrl('images/silent/bg.png')}>
      <video
        ref={videoRef}
        className={styles.video}
        src={getAssetUrl('videos/silent/welcome.mp4')}
        autoPlay
        muted
        loop
      />
    </Background>
  )
}

export default memo(Silent);
